// Module
var code = "<div ng-repeat=\"b in vm.formTemplate.blocks track by $index\" class=\"flex\" ng-class=\"b.config.classes\">\n    <form-block flex form-block=\"b\" template=\"vm.formTemplate\" on-change=\"vm.onChange()\"></form-block>\n</div>\n";
// Exports
module.exports = code;